import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { Country } from '../countries/country.interface';
import { SsnCountryService } from './ssn-country.service';

const service = new SsnCountryService();

export interface SsnCountryState {
   ssnCountries: Array<Country>;
}

const SsnCountryStore: Module<SsnCountryState, StoreState> = {
   namespaced: true,
   state: {
      ssnCountries: [],
   },
   getters: {},
   mutations: {
      SET_SSN_COUNTRIES(state, ssnCountries: Array<Country>) {
         state.ssnCountries = ssnCountries.map((ssnCountry) => ({ ...ssnCountry, iso_code_2: ssnCountry.country_code }));
      },
   },
   actions: {
      async getSsnCountries(context) {
         const { data: countries } = await service.getSsnCountries();
         context.commit('SET_SSN_COUNTRIES', countries);
         return countries;
      },
   },
};

export default SsnCountryStore;
